import { appType } from "../../utils/config/configHelpers";
import { getAuthData } from "../storage/LocalStorage";
import { getAccessToken } from "../../utils/tokenUtils";
import { handleIncomingMessage, initWebSocket, SOCKET } from "./initWebSocket";
import webSocketApiService from "./wsApiServices";


{/** Starts a conversation via socket with provided user and bot parameters.*/ }
export const startConversation = (userId, { conversationId = "", botId = "" }) => {
    const conversation = {
        conversationId,
        bot: botId,
        participants: [userId],
        onChannels: [],
        closed: false,
    };

    const messagePayload = {
        messageType: "init",
        message: {
            intentId: "main",
            OsVersion: "",
            brand: "",
            model: "",
            platform: "",
            userAgent: "",
        },
    };

    socketSendMessageFirstEvent(messagePayload, conversation);
};

{/** Emits another events to the socket.*/ }
export async function socketSendMessageEvent(req) {
  let ws = SOCKET.ws;

  if (!ws || ws.readyState !== WebSocket.OPEN) {
    try {
      console.log("socketSendMessageEvent: WebSocket not open, attempting reconnect...");
      const userDetail = getAuthData();
      const userData = userDetail?.user || {};
      const sessionId = userDetail.auth?.sessionId;

      const params = {
        email: userData.emailAddress || "",
        sessionId: sessionId,
        appType: appType,
        platform: "web",
        accessToken: getAccessToken()
      };
      
      console.log("params for reconnect", params);
      await initWebSocket(params, params.sessionId, null);
      ws = SOCKET.ws;
      console.log("socketSendMessageEvent: reconnect attempt finished", ws);
    } catch (e) {
      console.error("socketSendMessageEvent: reconnect failed", e);
    }
  }
  
  if (!ws || ws.readyState !== WebSocket.OPEN) {
    console.log("WebSocket not connected");
    return;
  }

  console.log("%c Sending messages by user to socket :", "color: green;", req)
  // console.log("%c Current pending requests before sending:", "color: purple;", Object.keys(SOCKET.pendingRequests));
  
  return new Promise((resolve, reject) => {
    SOCKET.pendingRequests[req.requestId] = { resolve, reject };
    // console.log("%c Added pending request:", "color: purple;", req.requestId);
    // console.log("%c Pending requests count after adding:", "color: purple;", Object.keys(SOCKET.pendingRequests).length);
    
    // console.log("%c WS <<< Sending on WebSocket instance:", "color: red;", ws);
    // console.log("%c WS <<< WebSocket onmessage handler:", "color: red;", ws.onmessage);
    
    // Ensure message handler is attached
    if (!ws.onmessage) {
      // console.error("%c WS <<< ERROR: WebSocket has no onmessage handler!", "color: red;");
      // console.log("%c WS <<< Re-attaching message handler...", "color: orange;");
      
      // Re-attach the message handler
      ws.onmessage = (event) => {
        // console.log("%c WS <<< Raw message received (re-attached):", "color: cyan;", event.data);
        // console.log("%c WS <<< Connection ID:", "color: cyan;", SOCKET.ws === ws ? "SAME_INSTANCE" : "DIFFERENT_INSTANCE");
        handleIncomingMessage(event.data);
      };
      
      console.log("%c WS <<< Message handler re-attached successfully", "color: green;");
    }
    
    ws.send(JSON.stringify(req));
  });
};

{/** Emits another events to the socket.*/ }
export const socketSendMessageFirstEvent = async (parametersData, conversation) => {

    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            "command": "sendMessage",
            "botId": conversation?.bot,
            "data": parametersData,
        }),
        sync: false,
        conversation
    };
    await webSocketApiService.AgentGuardService(payload)
};

export const socketSendMessageAnotherEvent = async (parametersData, conversation) => {

    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            "command": "sendMessage",
            "botId": conversation?.bot,
            "data": parametersData,
        }),
        sync: false,
        conversation: {
            conversationId: conversation?.conversationId,
            bot: conversation?.bot,
        },
    };
    await webSocketApiService.AgentGuardService(payload)
};
